import { useState } from "react";
import type { DomainIncomeType } from "@porchpass/api-client";
import type { GenericIncomeFormData } from "src/types/income";
import { IncomeOptions } from "src/constants";
import { toFormattedInteger } from "src/utils";
import DeleteIncomeModal from "./DeleteIncomeModal";
import { AddMoneyPlusIcon, FormTableSummaryCard } from "@porchpass/ui";

type IncomeItemProps = {
  incomeItem: GenericIncomeFormData;
  index?: number;
  editHandler: () => void;
  closeHandler: () => void;
  deleteHandler: () => void;
};

const formatDateRange = (from: string, to?: string): string => {
  if (!from) return "";

  const formatDate = (date: string) =>
    new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      timeZone: "UTC",
    });

  return to
    ? `From ${formatDate(from)} to ${formatDate(to)}`
    : `Since ${formatDate(from)}`;
};

const typeToTitle = (type: DomainIncomeType) =>
  IncomeOptions.find((item) => item.income_type === type)?.title;

export default ({
  incomeItem,
  index = 0,
  closeHandler,
  editHandler,
  deleteHandler,
}: IncomeItemProps) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const childrenAges = incomeItem.children_ages?.replaceAll(",", ", ");

  const subtitles =
    incomeItem.income_type === "CHILD_SUPPORT" ||
    incomeItem.income_type === "SSI_FOR_DEPENDENTS"
      ? [childrenAges ? `Children ages: ${childrenAges}` : ""].filter(Boolean)
      : [
          formatDateRange(incomeItem.start_date ?? "", incomeItem.end_date),
        ].filter(Boolean);

  return (
    <>
      <FormTableSummaryCard
        index={index}
        title={
          incomeItem.income_type
            ? (typeToTitle(incomeItem.income_type) ?? "Income")
            : "Income"
        }
        icon={
          <AddMoneyPlusIcon
            variant="bulk-rounded"
            size={16}
            className="text-[#BC3C7C]"
          />
        }
        subtitles={subtitles}
        amount={{
          value: `$${toFormattedInteger(incomeItem.amount)}`,
          suffix: "mo",
        }}
        onClick={editHandler}
        onEdit={editHandler}
        onDelete={() => setIsDeleteModalOpen(true)}
      />
      <DeleteIncomeModal
        isOpen={isDeleteModalOpen}
        income_id={incomeItem.id ?? ""}
        closeHandler={() => {
          setIsDeleteModalOpen(false);
          closeHandler();
        }}
        deleteHandler={() => {
          setIsDeleteModalOpen(false);
          deleteHandler();
        }}
      />
    </>
  );
};
